import { render, staticRenderFns } from "./paper-manage.vue?vue&type=template&id=14e3a8c8&scoped=true"
import script from "./paper-manage.vue?vue&type=script&lang=js"
export * from "./paper-manage.vue?vue&type=script&lang=js"
import style0 from "./paper-manage.vue?vue&type=style&index=0&id=14e3a8c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e3a8c8",
  null
  
)

export default component.exports